export const toCopyArray = (array: object[]) => {
  const copyArray: object[] = []
  array.forEach(item => {
    copyArray.push({ ...item })
  })
  return copyArray
}